export const PERSONA_ROLES = [
  'Administrator',
  'Analyst',
  'Associate',
  'Consultant',
  'Coordinator',
  'Director',
  'Engineer',
  'Manager',
  'Senior Vice President',
  'Specialist',
  'Supervisor',
  'Team Lead',
  'Vice President',
  'VP',
  'SVP'
];

export const PERSONA_DEPARTMENTS = [
  'Customer Success',
  'Data Science',
  'Finance',
  'Human Resources',
  'IT',
  'Information Technology',
  'Legal',
  'Marketing',
  'Operations',
  'Procurement',
  'Product',
  'R&D',
  'Sales',
  'Security',
  'Support',
  'Systems'
];

export const PERSONA_EXECUTIVES = [
  'CDO',
  'CEO',
  'CFO',
  'CIO',
  'CMO',
  'COO',
  'CPO',
  'CSO',
  'CTO',
  'CISO',
  'CXO',
  'Chief Data Officer',
  'Chief Executive Officer',
  'Chief Experience Officer',
  'Chief Financial Officer',
  'Chief Information Officer',
  'Chief Information Security Officer',
  'Chief Marketing Officer',
  'Chief Operating Officer',
  'Chief Product Officer',
  'Chief Strategy Officer',
  'Chief Technology Officer',
  'Co-Founder',
  'EVP',
  'Executive Vice President',
  'Founder',
  'Managing Director',
  'President',
  'Senior Vice President',
  'SVP'
];

export const PERSONA_INFLUENCERS = [
  ...PERSONA_EXECUTIVES,
  'Advisor',
  'Business Analyst',
  'Business Development Manager',
  'Consultant',
  'Director',
  'Engineering Manager',
  'Innovation Manager',
  'Operations Manager',
  'Manager',
  'Procurement Lead',
  'Product Manager',
  'Program Manager',
  'Project Manager',
  'Senior Manager',
  'Solutions Architect',
  'Strategy Manager',
  'Technical Lead'
].sort();

export const PERSONA_EXCLUDED = [
  'Admin',
  'Administrator',
  'Assistant',
  'Associate',
  'Clerk',
  'Coordinator',
  'Employee',
  'Entry-Level',
  'Intern',
  'Junior',
  'Operator',
  'Program Coordinator',
  'Project',
  'Receptionist',
  'Representative',
  'Secretary',
  'Specialist',
  'Staff',
  'Support',
  'Team Member',
  'Technician',
  'Trainee',
  'Worker'
];

export const PERSONA_DEFAULTS = {
  roles: ['director', 'vp', 'svp', 'vice president', 'president', 'manager', 'engineer'],
  departments: ['marketing', 'information', 'it', 'systems', 'operations'],
  executives: ['ceo', 'chief', 'svp', 'senior vice president', 'ciso', 'coo', 'cmo', 'cso', 'cio', 'cpo', 'cdo', 'cxo'],
  influencers: [
    'ceo',
    'chief',
    'svp',
    'senior vice president',
    'director',
    'strategy',
    'business development',
    'manager',
    'ciso',
    'coo',
    'cio',
    'cmo',
    'cpo',
    'cxo',
    'cdo',
    'cso'
  ],
  excluded: ['program coordinator', 'specialist', 'project']
};
